export const AGENT_CONVERSATIONS_PATH = 'agent/conversations';

/** The platform profile Commenda AI chat runs as. Every chat conversation is created bound to it,
 * and the list is filtered by it, so the builder's and research's threads stay out of Recents. */
export const COMMENDA_CHAT_PROFILE_KEY = 'COMMENDA_CHAT';

/** The platform profile the workflow agent runs as, in the builder panel and on its own pages. */
export const WORKFLOW_BUILDER_PROFILE_KEY = 'WORKFLOW_BUILDER';

/** The platform profile the research agent runs as. */
export const RESEARCH_AGENT_PROFILE_KEY = 'RESEARCH_AGENT';

/** The unified agent API outside conversations: attachments, reference previews and the per-profile
 * model catalogue. */
export const AGENT_PLATFORM_API_BASE_URL = `${process.env.NEXT_PUBLIC_SERVER_URL}/api/v1/agent`;

export const COMMENDA_AI_FILE_METADATA_KEY = 'commenda';

/** The server's cap on one typed message. Longer text goes in as an attached file instead. */
export const COMMENDA_AI_MESSAGE_MAX_LENGTH = 100_000;

/** Some machines report no type for a file (a .doc or .json with no app registered for it), and the upload
 * endpoint refuses an empty type, so it is filled in from the extension. */
export const COMMENDA_AI_ATTACHMENT_MIME_TYPE_BY_EXTENSION: Readonly<
  Record<string, string>
> = {
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  rtf: 'application/rtf',
  txt: 'text/plain',
  md: 'text/markdown',
  csv: 'text/csv',
  json: 'application/json',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  gif: 'image/gif',
  webp: 'image/webp',
};

export const DEFAULT_POLL_INTERVAL_MS = 2_000;

/** A run that never reports a terminal state must not poll forever; roughly twenty minutes at the
 * default interval, which is past the longest build the harness has produced. */
export const MAX_POLLS = 600;

/** A reply row whose run is not linked yet is settled only by its own status. */
export const SETTLED_MESSAGE_STATUSES: ReadonlySet<string> = new Set([
  'COMPLETED',
  'FAILED',
  'AWAITING_CONFIRMATION',
]);

/** How recent an unstarted turn must be for a reload to wait on it; older ones were abandoned. */
export const FRESH_TURN_MS = 10 * 60_000;

/** A reply still RUNNING past the poll budget was left behind by its worker (a deploy, a crash), so
 * a reload draws it as it stands instead of waiting on a run that will never report again. */
export const LIVE_REPLY_MS = MAX_POLLS * DEFAULT_POLL_INTERVAL_MS;

/** Profiles whose server marks dead runs failed, so the client trusts their run status with no age or poll cutoff. */
export const SERVER_RECOVERED_PROFILE_KEYS: ReadonlySet<string> = new Set([
  RESEARCH_AGENT_PROFILE_KEY,
]);

export const SEND_FAILED_MESSAGE = 'The message could not be sent.';

/** Required by the send's validation and ignored on a regenerate, for a turn that was files only. */
export const REGENERATE_PLACEHOLDER_MESSAGE = 'Regenerate';
